import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e87692a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-functions" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "functions-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "list-item-icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "list-item-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/添加.png",
    referrerpolicy: "no-referrer"
  })
], -1))
const _hoisted_9 = { class: "list-item-name" }

import { computed, onMounted, Ref, ref } from 'vue'
import { t } from '@/plugins/i18n'
import DialogCommonFunction from '../components/DialogCommonFunction'
import { getConfigApi } from '@/apis/user'
import { ENUM_CONFIG_CODE, ENUM_LEVEL } from '@/util/useUserConfig'
import { defaultFunctions, FunctionItems } from './data'
import store, { isJA, useRtfix, useSite } from '@/store'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { CustomerMembershipResDTO } from '@/apis/interface/customer'
import { ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const visible = ref(false)
const warningImg = require('@/assets/image/icon/member/icon_hint@2x.png')
/** 是否是子账户 */
const isSub = store.getters.isSub
const router = useRouter()
const site = useSite()
/** 会员信息 */
const membership: CustomerMembershipResDTO = store.getters.membership
const commonFunctionList: Ref<FunctionItems[]> = ref([])
/** 预留占位空间 */
const surplusArr: Ref<number[]> = ref([])

/** 获取已配置的功能 */
const getCommonFunction = async () => {
  const res = await getConfigApi({
    configCode: ENUM_CONFIG_CODE.WORKBENCH_MENU,
    level: isSub ? ENUM_LEVEL.CUSTOMER_ID : ENUM_LEVEL.MAIN_CUSTOMER_ID
  })
  /** 初始化状态为null */
  if (!res.data.configValue) {
    commonFunctionList.value = defaultFunctions
    const surplusLength = Math.abs(defaultFunctions.length - 5)
    surplusArr.value = new Array(surplusLength).fill(2)
    return
  }
  /** 已配置的功能 */
  const arr = JSON.parse(res.data.configValue)
  commonFunctionList.value = arr
  const surplusLength = Math.abs(arr.length - 5)
  surplusArr.value = new Array(surplusLength).fill(2)
}

onMounted(() => {
  getCommonFunction()
})

/** 跳转菜单 */
const handleAppLink = (item: FunctionItems) => {
  /** 我的物料 */
  if (item.path === 'materials') {
    return router.push(useRtfix('stock', { query: { stock: 'materials' } }))
  }
  if (['addFindSource', 'oemSourceList'].includes(item.path as string)) {
    if (item.path === 'addFindSource') {
      window.location.href = window.location.origin + `/oem/order/${item.path}?source=UserCenter`
      return
    }
    window.location.href = window.location.origin + `/oem/order/${item.path}`
  } else if (item.path === 'goodsList') {
    window.location.href = window.location.origin + '/oem/goods/list'
  } else if (item.path === 'costCalcList') {
    window.location.href = window.location.origin + `/${site}/costCalc/list`
  }

  /** 会员才可查看我的收藏、足迹、购买过内的商品哦 */
  if (['CollectProduct', 'AfterPurchase', 'FootPrint'].includes(item.path as string) && Number(membership.templateLevel) === 0) {
    ElMessageBox.confirm(
      `
        <img src='${warningImg}' style='position:absolute;top:-38px;height:20px;width:20px'/>
        <spn>${t('会员才可查看我的收藏、足迹、购买过内的商品哦')}</spn>
      `,
      t('注意3'),
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: t('会员登录'),
        cancelButtonText: t('关闭'),
        distinguishCancelAndClose: true,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        customClass: 'sidebarMemberConfirm'
      }
    )
      .then(() => {
        const routerUrl: any = router.resolve(useRtfix('VipLevel'))
        window.open(routerUrl.href, '_black')
      })
    return
  }
  return router.push(useRtfix(item.path as string))
}

/** 增加自定义功能 */
const addFunctions = () => {
  visible.value = true
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: { position: 'customize_common_feature' }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('常用功能')), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(commonFunctionList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "list-item",
            key: item.path
          }, [
            _createElementVNode("div", {
              class: "list-item",
              onClick: ($event: any) => (handleAppLink(item))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: item.icon
                }, null, 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
            ], 8, _hoisted_4)
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "list-item",
          onClick: addFunctions
        }, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('自定义常用功能')), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(surplusArr.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "list-item",
            key: index
          }))
        }), 128))
      ])
    ]),
    _createVNode(_unref(DialogCommonFunction), {
      visible: visible.value,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false)),
      commonFunctionList: commonFunctionList.value,
      onGetCommonFunction: getCommonFunction
    }, null, 8, ["visible", "commonFunctionList"])
  ], 64))
}
}

})